import { Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function BreadcrumbEstadistica({active}) {

    return <Breadcrumb>
            <Breadcrumb.Item><Link to="/">Inicio</Link></Breadcrumb.Item>
            <Breadcrumb.Item><Link to="/estadistica">Estadística</Link></Breadcrumb.Item>
            <Breadcrumb.Item active>{active}</Breadcrumb.Item>
        </Breadcrumb>
    
}